import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBatchUploaded = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M25.4031 9.43511V21.5319C25.4031 25.1609 23.5886 27.5803 19.3547 27.5803H9.67729C5.44342 27.5803 3.62891 25.1609 3.62891 21.5319V9.43511C3.62891 5.80607 5.44342 3.38672 9.67729 3.38672H19.3547C23.5886 3.38672 25.4031 5.80607 25.4031 9.43511Z",
			stroke: "#3CD1A3",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5405 6.41113V8.83049C17.5405 10.1611 18.6292 11.2498 19.9599 11.2498H22.3792",
			stroke: "#3CD1A3",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.67725 16.6934H14.516",
			stroke: "#3CD1A3",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.67725 21.5322H19.3547",
			stroke: "#3CD1A3",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9272 13.3067H24.5563C27.5805 13.3067 28.7901 12.0971 28.7901 9.07286V5.44383C28.7901 2.41964 27.5805 1.20996 24.5563 1.20996H20.9272C17.903 1.20996 16.6934 2.41964 16.6934 5.44383V9.07286C16.6934 12.0971 17.903 13.3067 20.9272 13.3067Z",
			fill: "#3CD1A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1714 7.25759L21.8831 8.96929L25.3125 5.5459",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBatchUploaded;
